<template>
  <div class="index">
    <one-content></one-content>
  </div>
</template>
<script>
export default {
    data(){
        return{
            
        }
    }
};
</script>
<style scoped>
.index{
    width: 1100px;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue